export default "__VITE_ASSET__BHGZRnNY__";